/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { UserDetails } from '../models/UserDetails';
import type { UserRoleCreate } from '../models/UserRoleCreate';
import type { UserRoleDetails } from '../models/UserRoleDetails';
import type { UserRolePermissionsDetails } from '../models/UserRolePermissionsDetails';
import type { UserRolePermissionUpdate } from '../models/UserRolePermissionUpdate';
import type { UserRoleUpdate } from '../models/UserRoleUpdate';
import { request as __request } from '../core/request';

export class UserRolesVService {

    /**
     * @param userRoleId
     * @returns UserRoleDetails OK
     * @throws ApiError
     */
    public static async userRolesVGetById(
        userRoleId: number,
    ): Promise<UserRoleDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/userRoles/${userRoleId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userRoleId
     * @param requestBody
     * @returns UserRoleDetails OK
     * @throws ApiError
     */
    public static async userRolesVUpdateUserRole(
        userRoleId: number,
        requestBody?: UserRoleUpdate,
    ): Promise<UserRoleDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/userRoles/${userRoleId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UserDetails Created
     * @throws ApiError
     */
    public static async userRolesVCreate(
        requestBody?: UserRoleCreate,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/userRoles`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async userRolesVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/userRoles/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UserRoleDetails OK
     * @throws ApiError
     */
    public static async userRolesVGetExport(
        requestBody?: PagingQuery,
    ): Promise<UserRoleDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/userRoles/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userRolePermissionId
     * @param requestBody
     * @returns UserRolePermissionsDetails OK
     * @throws ApiError
     */
    public static async userRolesVUpdatePermissions(
        userRolePermissionId: number,
        requestBody?: UserRolePermissionUpdate,
    ): Promise<UserRolePermissionsDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/userRoles/permissions/${userRolePermissionId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}